import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { FontIcon } from 'react-md';

import ButtonAction from '../../Common/Blocks/ButtonAction';

import { ActionButtonEnum } from '../QuotationBlock.enum';

/**
 * Part
 * @param {*} param0
 */
const Partie = ({ title, show, hidden, disabled, isSubscriber, setShowPartie, removePartie, children }) =>
  !hidden ? (
    <div className="part">
      <div className="head">
        <FontIcon className={cn({ show, hide: !show })}>change_history</FontIcon>
        <span className="title" role="presentation" onClick={setShowPartie}>
          {title}
        </span>
        {isSubscriber !== true && (
          <ButtonAction disabled={disabled} typeAction={ActionButtonEnum.REMOVE} action={removePartie} />
        )}
      </div>
      <div style={{ display: !show ? 'none' : undefined }} className="body">
        {children}
      </div>
    </div>
  ) : (
    ''
  );

Partie.propTypes = {
  title: PropTypes.string,
  show: PropTypes.bool.isRequired,
  isSubscriber: PropTypes.bool.isRequired,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  setShowPartie: PropTypes.func.isRequired,
  removePartie: PropTypes.func,
  children: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
};
Partie.defaultProps = {
  title: undefined,
  hidden: false,
  disabled: false,
  removePartie: () => {},
};

export default Partie;
